import { TextInputSize, Valideringstype } from '../../types/generated-types';
import { isInputTooLong } from '../validation/validate';

export const getFeilmeldingFrom = (
    valideringstype: Valideringstype,
    value: string = undefined,
    textInputSize: TextInputSize = undefined,
    maxNumberOfCharacters: number = undefined,
): string => {
    if (maxNumberOfCharacters && value.length > maxNumberOfCharacters)
        return `Svaret kan maks inneholde ${maxNumberOfCharacters} tegn. Det er nå ${value.length} tegn.`;
    switch (valideringstype) {
        case Valideringstype.Kontonummer:
            return 'Du må oppgi et gyldig kontonummer med 11 siffer.';
        case Valideringstype.Skadenummer:
            return 'Du må oppgi et gyldig skadenummer som kun inneholder tall og et punktum (f.eks. 1234567.1)';
        case Valideringstype.Epost:
            return 'Vi trenger en e-postadresse for å kunne kontakte deg. Er du sikker på at du har skrevet inn e-postadressen riktig?';
        case Valideringstype.Pakrevd:
            if (
                (textInputSize === TextInputSize.ExtraSmall ||
                    textInputSize === TextInputSize.Smaller ||
                    textInputSize === TextInputSize.Small) &&
                isInputTooLong(value)
            )
                return 'Svaret du har oppgitt er for langt, det kan ikke overstige 150 tegn.';
            return 'Her må du gi et svar for å gå videre.';
        case Valideringstype.Fodselsnummer:
            return 'Her mangler det et gyldig fødselsnummer. Fødselsnummer består av fødselsdato (DDMMÅÅ) og personnummer (5 siffer)';
        case Valideringstype.Mobilnummer:
            return 'Vi trenger et norsk mobilnummer (8 siffer) for å kunne kontakte deg.';
        case Valideringstype.ValgfrittMobilnummer:
            return 'Vi trenger et norsk mobilnummer (8 siffer).';
        case Valideringstype.ValgfrittTelefonnummer:
            return 'Vi trenger et norsk telefonnummer (8 siffer).';
        case Valideringstype.Postnummer:
            return 'Vi trenger et norsk postnummer.';
        default:
            return '';
    }
};

export const getValideringsTypeFrom = (valideringstype: string): Valideringstype => {
    switch (valideringstype) {
        case 'Kontonummer':
            return Valideringstype.Kontonummer;
        case 'Epost':
            return Valideringstype.Epost;
        case 'Pakrevd':
            return Valideringstype.Pakrevd;
        case 'Fodselsnummer':
            return Valideringstype.Fodselsnummer;
        case 'Mobilnummer':
            return Valideringstype.Mobilnummer;
        case 'ValgfrittMobilnummer':
            return Valideringstype.ValgfrittMobilnummer;
        case 'ValgfrittTelefonnummer':
            return Valideringstype.ValgfrittTelefonnummer;
        case 'Postnummer':
            return Valideringstype.Postnummer;
        default:
            return Valideringstype.Valgfritt;
    }
};
